import React from 'react';
import PropTypes from 'prop-types';
import { GalleryModalDual } from '../GalleryModalDual';
import { useGallery } from '../../../hooks/useGallery';
import { useNotifications } from '../../../hooks/useNotifications';

function UserGalleryDual({ open, onClose, setFile, width, height }) {
  const { enqueueSnackbar } = useNotifications();

  const notifyDefaultError = (message) =>
    enqueueSnackbar({
      message: message || 'Something went wrong',
      options: {
        variant: 'error',
      },
    });

  const callbacks = {
    'upload-success': () =>
      enqueueSnackbar({
        message: 'File was successfully uploaded',
        options: {
          variant: 'success',
        },
      }),
    'delete-success': () =>
      enqueueSnackbar({
        message: 'File was successfully deleted',
        options: {
          variant: 'success',
        },
      }),
    'edit-success': () =>
      enqueueSnackbar({
        message: 'Image was successfully edited',
        options: {
          variant: 'success',
        },
      }),
    'upload-error': notifyDefaultError,
    'config-error': notifyDefaultError,
    'load-error': notifyDefaultError,
    'delete-error': notifyDefaultError,
    'edit-error': notifyDefaultError,
  };

  return (
    <GalleryModalDual
      setFile={setFile}
      open={open}
      onClose={onClose}
      GalleryProviderHooks={[
        {
          name: 'User Uploads',
          hook: useGallery,
          main: true,
          showOriginal: true,
        },
      ]}
      actionCallback={(e) => {
        console.log('Gallery action callback:', e);
        const callback = callbacks[`${e.type}-${e.status}`];
        if (callback) callback(e.payload?.message);
      }}
      width={width}
      height={height}
    />
  );
}

UserGalleryDual.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  setFile: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

UserGalleryDual.defaultProps = {
  open: false,
  width: 630,
  height: 330,
};

export default UserGalleryDual;
